import React from "react"
import styled from "styled-components"
import OutlineCloseIcon from "../icons/OutlineCloseIcon";
import {useLocale, useMenu} from "../../context/AppContext";
import useTranslation from "../../utils/translation";
import {useNavigate} from "react-router-dom";
import WhiteButton from "../buttons/WhiteButton";
import {sizes} from "../../utils/media";
import useWindowDimensions from "../../utils/windowSize";
import OutlineHomeIcon from "../icons/OutlineHomeIcon";
import OutlineInfoIcon from "../icons/OutlineInfoIcon";
import OutlineShoppingIcon from "../icons/OutlineShoppingIcon";
import PowerSupplyIcon from "../icons/PowerSupplyIcon";

const MenuContainer = styled.div`
  position: fixed;
  right: 0;
  width: ${p => p.isOpen ? (p.width <= sizes.desktop ? "100%" : "360px") : 0};
  height: 100%;
  z-index: 999;
  background-color: white;
  display: flex;
  flex-direction: column;
  transition: width 0.2s ease;
  overflow: hidden;
`

const MenuText = styled.span`
  display: flex;
  align-self: start;
  margin: auto;
  font-size: 24px;
  font-weight: 700;
`

const MenuTextLink = styled.a`
  display: flex;
  align-self: start;
  margin: auto;
  font-size: 24px;
  font-weight: 700;
  text-decoration: none;
  &:focus, &:hover {
    color: black;
    text-decoration: none;
  }
`

const MenuHeader = styled.div`
  display: flex;
  justify-content: end;
  margin: 10px 10px;
`

const MenuContent = styled.div`
  margin: 35px;
`

const MenuContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  overflow-x: hidden;
`;

const MenuFooter = styled.div`
  padding: 20px 0;
  text-align: center;
  font-size: 14px;

  a {
    color: #333;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const Menu = () => {
  const t = useTranslation()
  const {language} = useLocale()
  const {menuIsOpen, setMenuIsOpen} = useMenu()
  const {width} = useWindowDimensions();
  const navigate = useNavigate();

  const close = () => setMenuIsOpen(false)

  const onMenuItemClick = (path) => {
    close();
    navigate(path)
  }

  return (
    <MenuContainer isOpen={menuIsOpen} width={width}>
      <MenuHeader>
        <OutlineCloseIcon bold={true} onClick={close}/>
      </MenuHeader>
      <MenuContentWrapper>
        <MenuContent>
          <WhiteButton onClick={() => onMenuItemClick("/")} border={false}>
            <MenuText>
              <OutlineHomeIcon margin={"auto 10px"}/>{t("common.home")}
            </MenuText>
          </WhiteButton>
          <WhiteButton border={false}>
            <MenuTextLink href={language === "en" ? "https://www.toppowernordic.com/" : "https://www.toppowernordic.se/"} target="_blank" rel="noreferrer">
              <PowerSupplyIcon margin={"auto 10px"}/>{t("common.powersupply")}
            </MenuTextLink>
          </WhiteButton>
          <WhiteButton border={false}>
            <MenuTextLink href={"https://shop.toplednordic.com/"} target="_blank" rel="noreferrer">
              <OutlineShoppingIcon margin={"auto 10px"}/>{t("common.productsAndShop")}
            </MenuTextLink>
          </WhiteButton>
          <WhiteButton onClick={() => onMenuItemClick("/aboutus")} border={false}>
            <MenuText>
              <OutlineInfoIcon margin={"auto 10px"}/>{t("common.aboutus")}
            </MenuText>
          </WhiteButton>
        </MenuContent>
        <MenuFooter>
          <a
            href={`/static/docs/IML_${(language || "en").toUpperCase()}.pdf`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("common.tos")} ↗
          </a>
        </MenuFooter>
      </MenuContentWrapper>
    </MenuContainer>
  );
}

export default Menu;
